module.exports = __webpack_public_path__ + "img/sunlei_special_postdoctoral_fund.bd2360dc.png";